import error from '@loggi/js/log-error';

export default function getWindow() {
  if (!window) {
    error('could not find "window"');
    return null;
  }

  return window;
}

export function getNavigator() {
  const $window = getWindow();

  if (typeof $window === 'object' && !!$window.navigator) {
    return $window.navigator;
  }

  return null;
}
